import React from "react";

const MyVehiclesIcon = ({
  width = "20",
  height = "16",
  active = false,
  activeColor = "#1D5AB9",
  inActiveColor = "#969998",
  color = active ? activeColor : inActiveColor,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_620_22588)">
        <path
          d="M11 1.5C11.275 1.5 11.5 1.725 11.5 2V11C11.5 11.275 11.275 11.5 11 11.5H10H7.6C7.08125 10.6031 6.1125 10 5 10C3.8875 10 2.91875 10.6031 2.4 11.5H2C1.725 11.5 1.5 11.275 1.5 11V2C1.5 1.725 1.725 1.5 2 1.5H11ZM12 13C12 14.6562 13.3438 16 15 16C16.6562 16 18 14.6562 18 13H19.25C19.6656 13 20 12.6656 20 12.25C20 11.8344 19.6656 11.5 19.25 11.5H19V7.66563C19 7.2 18.8156 6.75625 18.4875 6.42812L15.5719 3.5125C15.2437 3.18438 14.8 3 14.3344 3H13V2C13 0.896875 12.1031 0 11 0H2C0.896875 0 0 0.896875 0 2V11C0 12.1031 0.896875 13 2 13C2 14.6562 3.34375 16 5 16C6.65625 16 8 14.6562 8 13H10H11H11.75H12ZM17.4281 7.4875C17.4312 7.49063 17.4375 7.49687 17.4406 7.5H13V4.5H14.3344C14.4 4.5 14.4656 4.525 14.5125 4.57188L17.4281 7.4875ZM3.5 13C3.5 12.6022 3.65804 12.2206 3.93934 11.9393C4.22064 11.658 4.60218 11.5 5 11.5C5.39782 11.5 5.77936 11.658 6.06066 11.9393C6.34196 12.2206 6.5 12.6022 6.5 13C6.5 13.3978 6.34196 13.7794 6.06066 14.0607C5.77936 14.342 5.39782 14.5 5 14.5C4.60218 14.5 4.22064 14.342 3.93934 14.0607C3.65804 13.7794 3.5 13.3978 3.5 13ZM15 11.5C15.3978 11.5 15.7794 11.658 16.0607 11.9393C16.342 12.2206 16.5 12.6022 16.5 13C16.5 13.3978 16.342 13.7794 16.0607 14.0607C15.7794 14.342 15.3978 14.5 15 14.5C14.6022 14.5 14.2206 14.342 13.9393 14.0607C13.658 13.7794 13.5 13.3978 13.5 13C13.5 12.6022 13.658 12.2206 13.9393 11.9393C14.2206 11.658 14.6022 11.5 15 11.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_620_22588">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MyVehiclesIcon;
